import {
  getAntibodyLink,
  getBlockLink,
  getOrderLink,
  getSampleLink,
  getSlideLink,
  STAIN_TYPES,
} from 'components/OrderSlidesList/SlideActionTabs/constants';

export const getSlideMeta = (slide, order, isStaff) => {
  const metadata = [
    {
      label: 'Name',
      value: slide.name,
      tooltip: slide.name,
      editable: true,
      link: getSlideLink(slide.uuid),
    },
    {
      label: 'Order',
      value: slide.order?.name,
      link: getOrderLink(slide.order?.uuid),
    },
    {
      label: 'Stain Type',
      value: STAIN_TYPES.find((stain) => stain.name === slide.stain_type)
        ?.displayName,
      editable: true,
    },
    {
      label: 'Antibody',
      antibodyUUID: slide.antibody?.uuid,
      value: slide.antibody?.name,
      valueTooltip: slide.antibody ? 'View Antibody in Catalog (New Tab)' : '',
      link: getAntibodyLink(slide.antibody?.uuid),
      editable: isStaff,
    },
    {
      label: 'Species',
      value: slide.sample?.species?.name,
      sampleLink: getSampleLink(slide.sample?.id),
      editable: !!slide.sample,
    },
    {
      label: 'Organ',
      value: slide.sample?.organ?.name,
      sampleLink: getSampleLink(slide.sample?.id),
      editable: !!slide.sample,
    },
    {
      label: 'Sample',
      value: slide.sample?.name,
    },
    {
      label: 'Block',
      value: slide.sample?.block?.name,
      link: getBlockLink(slide.sample?.block?.uuid),
    },
    {
      label: 'Scanner Type',
      value: slide.scanner_type,
    },
    {
      label: 'Fixative',
      value: order?.fixative?.name,
    },
    {
      label: 'Fixation Time',
      value: slide.sample?.fixation_time_hours,
    },
    {
      label: 'Height',
      value: slide.height,
    },
    // {
    //  label: 'Comments',
    //  value: slide.comments_flattened,
    // },
    {
      label: 'Slide Label Text',
      value: slide.thumbnail_ocr_text,
    },
  ];

  if (slide.alias) {
    metadata.splice(1, 0, {
      label: 'Alias',
      value: slide.alias,
      editable: true,
    });
  }

  if (slide.special_stain && slide.stain_type === 'special_stain') {
    metadata.push({
      label: 'Special Stain',
      value: slide.special_stain.name,
      editable: true,
    });
  }

  if (slide.comments_flattened) {
    metadata.push({
      label: 'Slide Comments',
      value: slide.comments_flattened,
      editable: false,
    });
  }

  return metadata;
};

export const getPayload = (formData = {}) => {
  const { Alias, 'Stain Type': stainType, Antibody, SpecialStain } = formData;
  const payload = {};
  if (Alias) payload.alias = Alias;
  if (stainType !== undefined) payload.stain_type = stainType;
  if (Antibody !== undefined) payload.antibody_uuid = Antibody;
  if (SpecialStain !== undefined) payload.special_stain_uuid = SpecialStain;

  return payload;
};
